import React from 'react';
import { ExternalLink } from 'lucide-react';

export const BlogCard = ({ post }) => (
  <article
    style={{
      background: 'var(--white)',
      borderRadius: '1rem',
      overflow: 'hidden',
      boxShadow: 'var(--shadow-md)',
      transition: 'var(--transition-base)',
      cursor: 'pointer'
    }}
    data-testid={`blog-card-${post.id}`}
  >
    <div
      style={{
        height: '200px',
        background: 'var(--gradient-gold)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#0F2C59',
        fontSize: '1.125rem',
        fontWeight: 700
      }}
    >
      {post.category}
    </div>
    <div style={{ padding: '1.5rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '1rem',
          fontSize: '0.875rem',
          color: 'var(--text-muted)'
        }}
      >
        <span>{post.publishDate}</span>
        <span>•</span>
        <span>{post.readTime}</span>
      </div>
      <h3 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--primary-navy)', marginBottom: '0.75rem' }}>
        {post.title}
      </h3>
      <p className="body-small" style={{ marginBottom: '1rem' }}>
        {post.excerpt}
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          color: 'var(--accent-gold-dark)',
          fontWeight: 600,
          fontSize: '0.875rem'
        }}
      >
        Read More
        <ExternalLink size={14} />
      </div>
    </div>
  </article>
);
